// Angular
import '@angular/animations';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/compiler';
import '@angular/http';
import '@angular/router';
import '@angular/forms';

// RxJS
// import 'rxjs';
import 'rxjs';

import '@ng-bootstrap/ng-bootstrap';
import 'ng2-ckeditor';
import 'ng2-file-upload';
import 'ng2-dnd';
import 'angular2-text-mask';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
// import '../../libs/jquery/jquery.min.js';
// import '../../libs/bootstrap/bootstrap.min.js';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/vendor.ts